<template lang="pug">
  .tree-wrapper.ranking-box-wrapper
    h1 Ranking
    ul.ranking
      li(v-for="item in items")
        label {{item.name}}
        span {{item.points}}
</template>

<script type="text/javascript">
import _ from "underscore";
import api from "@/service/api";
import { mapState } from "vuex";

export default {
  name: "Ranking",
  computed: mapState([
    "token", "username",
  ]),
  data() {
    return {
      items: [],
    };
  },
  async created() {
    const self = this;

    const resultItems = await api.ranking()
    self.items = resultItems.data.items
  },
};
</script>
